// extracted by mini-css-extract-plugin
export default {"notFoundContent":"search-user_notFoundContent__YXKqK"};